import get from 'lodash/get';
import { SlotType } from '@rome/response/page/v4/SlotType';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import * as actions from 'actions/pageActionsV4';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import { BrowsePages } from 'constants/pageTypes';
import { LayoutSectionType } from '@rome/response/page/v4/layout/LayoutSectionType';
const { PAGE_DATA_ACTIONS } = actions;
/* Added else condition dusing SFL rendering;  Earlier we were adding data only if corresponding id is present in previous data, Missing Case:  when parent is part of old response and we are appending child in later */
function appendContent(oldData, newSlots) {
    const { pageTree: newData } = createPageTree(newSlots);
    Object.keys(newData).forEach(item => {
        if (oldData.hasOwnProperty(item)) {
            oldData[item].push(...newData[item]);
        }
        else {
            oldData[item] = newData[item];
        }
    });
    return oldData;
}
/* appendContent appends data for a nested call when it gets, replaceSlotData replaces the content of the child slot than appending to it */
function replaceSlotData(oldData, newSlots) {
    const { pageTree: newData } = createPageTree(newSlots);
    Object.keys(newData).forEach(item => {
        if (oldData.hasOwnProperty(item) && item !== 'ROOT') {
            oldData[item] = newData[item];
        }
    });
    return oldData;
}
export function createPageTree(slotData) {
    const pageTree = {
        ROOT: []
    };
    let parentSectionId = undefined;
    slotData.forEach((data) => {
        if (!data.id)
            return;
        if (data.slotType === SlotType.LOGICAL) {
            const sectionType = get(data, ['layoutParams', 'sectionType']);
            if (sectionType === LayoutSectionType.PARENT && data.id !== undefined) {
                // this logic suffices only when we have only have one section for the whole page
                // visit the PR #6970 for more info
                parentSectionId = data.id;
            }
            if (!pageTree[data.id])
                pageTree[data.id] = [];
        }
        if (!data.parentId || data.parentId === 0) {
            pageTree.ROOT.push(data);
        }
        else {
            if (!pageTree[data.parentId]) {
                pageTree[data.parentId] = [];
            }
            pageTree[data.parentId].push(data);
        }
    });
    return { pageTree, parentSectionId };
}
const defaultState = {
    asyncStatus: AsyncStatus.INIT,
    data: { ROOT: [] },
    pageNumber: 0,
    timeStamp: new Date().getTime()
};
export default function (state = defaultState, action) {
    let slots = get(action, 'data.slots');
    switch (action.type) {
        case PAGE_DATA_ACTIONS.REQUEST:
            const isReloadRequest = !!get(action, 'requestContext.isReloadRequest');
            return Object.assign(Object.assign({}, state), { prevPageType: state.pageType || action.pageType, pageType: action.pageType, asyncStatus: AsyncStatus.LOADING, reloadParams: isReloadRequest ? state.reloadParams : undefined, reload: false });
        case PAGE_DATA_ACTIONS.LOAD_MORE_CONTENT_SUCCESS:
            if (!slots)
                return state;
            if (action.pageType && BrowsePages.indexOf(action.pageType) > -1) {
                let parentSlotId;
                slots = slots.filter(slot => {
                    const selected = slot.slotType === SlotType.WIDGET &&
                        (get(slot, 'widget.type') === WidgetTypeV4.PRODUCT_SUMMARY ||
                            get(slot, 'widget.type') === WidgetTypeV4.PAGINATION_BAR);
                    if (!parentSlotId && selected === true) {
                        parentSlotId = slot.parentId;
                    }
                    return selected;
                });
                // Code to remove the existing pagination bar widget and replace it with the new one
                if (parentSlotId && state.data[parentSlotId]) {
                    state.data[parentSlotId] = state.data[parentSlotId].filter(slot => get(slot, 'widget.type') !== WidgetTypeV4.PAGINATION_BAR);
                }
            }
            return Object.assign(Object.assign({}, state), { data: appendContent(Object.assign({}, state.data), slots), pageNumber: get(action.requestContext, 'pageContext.pageNumber', state.pageNumber || 1), pageType: action.pageType, responseHeaderObject: action.responseHeaderObject, pageData: action.data.pageData, pageMeta: action.data.pageMeta, asyncStatus: AsyncStatus.SUCCESS });
        case PAGE_DATA_ACTIONS.SUCCESS:
            if (!slots)
                return state;
            // we need to keep previous subpage data for cases when we have two v4 fetch calls in the same page
            const prevSubPageResponseMap = get(state, ['subPageResponse']) || {};
            const subPageResponseMap = Object.assign(Object.assign({}, prevSubPageResponseMap), get(action, ['data', 'subPageResponseMap']));
            const pageEventResponseMap = get(action, [
                'data',
                'pageData',
                'pageEventResponseMap'
            ]);
            const pageNumber = get(action.requestContext, 'pageContext.pageNumber', state.pageNumber || 1);
            const isBrowsePage = action.pageType && BrowsePages.indexOf(action.pageType) > -1;
            if (isBrowsePage && action.paginatedFetch) {
                const data = Object.assign({}, state.data);
                if (slots) {
                    const { pageTree: newData } = createPageTree(slots);
                    delete newData.ROOT;
                    Object.assign(data, newData);
                }
                return Object.assign(Object.assign({}, state), { data, fetchId: action.fetchId, responseHeaderObject: action.responseHeaderObject, pageType: action.pageType, pageData: action.data.pageData, pageMeta: action.data.pageMeta, asyncStatus: AsyncStatus.SUCCESS, pageNumber, timeStamp: new Date().getTime(), priceTimerExpired: false, subPageResponse: subPageResponseMap, pageEventResponseMap });
            }
            if (action.paginatedFetch && action.hasMorePages) {
                return Object.assign(Object.assign({}, state), { data: appendContent(Object.assign({}, state.data), action.data.slots), pageNumber, responseHeaderObject: action.responseHeaderObject, pageType: action.pageType, pageData: action.data.pageData, pageMeta: action.data.pageMeta, asyncStatus: AsyncStatus.SUCCESS, priceTimerExpired: false, subPageResponse: subPageResponseMap, pageEventResponseMap });
            }
            if (action.isNestedPage) {
                return Object.assign(Object.assign({}, state), { data: replaceSlotData(Object.assign({}, state.data), action.data.slots), pageNumber, responseHeaderObject: action.responseHeaderObject, pageType: action.pageType, pageData: action.data.pageData, pageMeta: action.data.pageMeta, asyncStatus: AsyncStatus.SUCCESS, isNestedPage: false, priceTimerExpired: false, subPageResponse: subPageResponseMap, pageEventResponseMap });
            }
            return Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.SUCCESS, fetchId: action.fetchId, responseHeaderObject: action.responseHeaderObject, data: createPageTree(slots).pageTree, pageType: action.pageType, pageNumber, pageData: action.data.pageData, pageMeta: action.data.pageMeta, timeStamp: new Date().getTime(), subPageResponse: subPageResponseMap, pageEventResponseMap });
        case PAGE_DATA_ACTIONS.ERROR:
            return Object.assign(Object.assign({}, state), { asyncStatus: AsyncStatus.ERROR, error: action.error });
        case PAGE_DATA_ACTIONS.CLEAR:
            return defaultState;
        case PAGE_DATA_ACTIONS.RELOAD:
            return Object.assign(Object.assign({}, state), { pageNumber: defaultState.pageNumber, reload: true, reloadParams: action.params });
        case PAGE_DATA_ACTIONS.SET_IS_NESTED_PAGE:
            return Object.assign(Object.assign({}, state), { isNestedPage: true });
        case PAGE_DATA_ACTIONS.PRICE_TIMER_EXPIRED:
            return Object.assign(Object.assign({}, state), { priceTimerExpired: true });
        default:
            return state;
    }
}
